import accountManagementActionTypes from './action-types';

export const fetchRequestOtpInfo = payload => ({
  type: accountManagementActionTypes.FETCH_REQUEST_OTP_INFO,
  payload,
});

export const fetchRequestOtpInfoSuccess = payload => ({
  type: accountManagementActionTypes.FETCH_REQUEST_OTP_INFO_SUCCESS,
  payload,
});

export const fetchRequestOtpInfoFail = payload => ({
  type: accountManagementActionTypes.FETCH_REQUEST_OTP_INFO_FAIL,
  payload,
});

export const fetchSignWithOtpInfo = payload => ({
  type: accountManagementActionTypes.FETCH_SIGN_WITH_OTP_INFO,
  payload,
});

export const fetchSignWithOtpInfoSuccess = payload => ({
  type: accountManagementActionTypes.FETCH_SIGN_WITH_OTP_INFO_SUCCESS,
  payload,
});

export const fetchSignWithOtpInfoFail = payload => ({
  type: accountManagementActionTypes.FETCH_SIGN_WITH_OTP_INFO_FAIL,
  payload,
});

export const fetchLoginInfo = payload => ({
  type: accountManagementActionTypes.FETCH_LOGIN_INFO,
  payload,
});

export const fetchLoginInfoSuccess = payload => ({
  type: accountManagementActionTypes.FETCH_LOGIN_INFO_SUCCESS,
  payload,
});

export const fetchLoginInfoFail = payload => ({
  type: accountManagementActionTypes.FETCH_LOGIN_INFO_FAIL,
  payload,
});
